var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#4972f4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_417_34884",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_417_34884)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_417_34884",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9531 2.32642H1.04736V17.6743H18.9531V2.32642Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_417_34884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02379 9.3607H1.04736V7.11213C1.04736 6.64421 1.23324 6.19546 1.56411 5.86459C1.89498 5.53372 2.34373 5.34784 2.81165 5.34784H5.98879V4.36142C5.9951 3.82366 6.21152 3.3097 6.5918 2.92943C6.97208 2.54915 7.48603 2.33272 8.02379 2.32642H11.8602C12.431 2.34274 12.9747 2.57288 13.3838 2.97122C13.7928 3.36956 14.0373 3.90703 14.0688 4.47713V5.3507H17.1902C17.6581 5.3507 18.1069 5.53658 18.4378 5.86745C18.7686 6.19832 18.9545 6.64707 18.9545 7.11499V9.36213H11.9759C11.9759 9.62168 11.9248 9.87868 11.8255 10.1185C11.7262 10.3583 11.5806 10.5761 11.3971 10.7597C11.2135 10.9432 10.9956 11.0888 10.7559 11.1881C10.5161 11.2874 10.2591 11.3386 9.99951 11.3386C9.73996 11.3386 9.48295 11.2874 9.24316 11.1881C9.00337 11.0888 8.78549 10.9432 8.60196 10.7597C8.41843 10.5761 8.27285 10.3583 8.17352 10.1185C8.0742 9.87868 8.02308 9.62168 8.02308 9.36213L8.02379 9.3607ZM12.1516 5.35142V4.47713C12.1528 4.42479 12.1436 4.37273 12.1246 4.32394C12.1056 4.27514 12.0772 4.23057 12.041 4.19276C12.0048 4.15495 11.9615 4.12465 11.9135 4.10358C11.8656 4.08252 11.814 4.0711 11.7616 4.06999H8.31308C8.26086 4.06875 8.20892 4.07783 8.16021 4.0967C8.11151 4.11558 8.06701 4.14387 8.02926 4.17996C7.9915 4.21606 7.96124 4.25924 7.9402 4.30705C7.91916 4.35485 7.90776 4.40634 7.90665 4.45856V5.3507L12.1516 5.35142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5343 10.7564H12.7343C12.5804 11.3525 12.2232 11.8761 11.7244 12.237C11.2256 12.5978 10.6164 12.7732 10.0021 12.7328C9.38734 12.7739 8.77754 12.5988 8.27814 12.2379C7.77874 11.877 7.42113 11.353 7.26712 10.7564H1.10498V17.6743H18.9521V10.7564H14.5343Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.2eca2000e5c39d2d6d1c5d0304e65fb3.svg";
export { ForwardRef as ReactComponent };